import taskmanAxios from '../helpers/axios'
import {
    API_WORKSPACE_MEMBERS_URL,
    API_MAKE_WORKSPACE_MEMBER_URL,
    API_MAKE_WORKSPACE_MEMBERS_GET_URL,
    API_MAKE_WORKSPACE_MEMBERS_PHOTOS_URL,
    API_MAKE_WORKSPACE_INVITATION_URL,
    API_MAKE_WORKSPACE_INVITATION_RESEND_URL,
    API_PROJECT_MEMBERS_URL,
    API_MAKE_PROJECT_MEMBERS_GET_URL,
    API_MAKE_PROJECT_MEMBER_REMOVE_URL,
} from '../constants/api.constant'

export default class WorkspaceMembersService {

    static async getMembers(workspaceId: number, params?: { skip?: number; limit?: number }) {
        return await taskmanAxios.get(API_MAKE_WORKSPACE_MEMBERS_GET_URL(workspaceId), { params })
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async getMemberPhotos(workspaceId: number, params?: { skip?: number; limit?: number }) {
        return await taskmanAxios.get(API_MAKE_WORKSPACE_MEMBERS_PHOTOS_URL(workspaceId), { params })
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async addMember(data: {
        user_id: string
        workspace_id: number
        role_in_workspace: string
    }) {
        return await taskmanAxios.post(API_WORKSPACE_MEMBERS_URL, data)
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async updateMember(memberId: number | string, data: {
        role_in_workspace?: string
        first_name?: string
        last_name?: string
    }) {
        return await taskmanAxios.put(API_MAKE_WORKSPACE_MEMBER_URL(memberId), data)
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async deleteMember(memberId: number | string) {
        return await taskmanAxios.delete(API_MAKE_WORKSPACE_MEMBER_URL(memberId))
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async cancelInvitation(workspaceId: number, invitationId: string | number) {
        return await taskmanAxios.delete(API_MAKE_WORKSPACE_INVITATION_URL(workspaceId, invitationId))
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async resendInvitation(workspaceId: number, invitationId: string | number) {
        return await taskmanAxios.post(API_MAKE_WORKSPACE_INVITATION_RESEND_URL(workspaceId, invitationId), {})
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async getProjectMembers(projectId: number, params?: { skip?: number; limit?: number }) {
        return await taskmanAxios.get(API_MAKE_PROJECT_MEMBERS_GET_URL(projectId), { params })
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async addProjectMember(data: {
        user_id: string
        project_id: number
        role_in_project?: string
    }) {
        return await taskmanAxios.post(API_PROJECT_MEMBERS_URL, {
            role_in_project: 'MEMBER',
            ...data,
        })
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }

    static async removeProjectMember(projectId: number, userId: string | number) {
        return await taskmanAxios.delete(API_MAKE_PROJECT_MEMBER_REMOVE_URL(projectId, userId))
            .then(response => response.data)
            .catch(e => Promise.reject(e))
    }
}
